import {Link} from 'react-router';

import {DataTable} from '@/components/dataTable';
import {DataTableRpc, DataTableRpcRefT} from '@/components/dataTableRpc';

type MarketSelectionModalPropsT = {
  onSelect: (market: {market_id: number; market_name: string}) => void;
  type: 'buy' | 'sell';
  marketRef?: React.RefObject<DataTableRpcRefT>;
};

const filterBtns = [
  {
    class: 'primary',
    label: 'Category',
  },
  {
    class: 'secondary',
    label: 'Sub Category',
  },
];

interface HSOverlay {
  close: (element: HTMLElement) => void;
}

declare global {
  interface Window {
    HSOverlay: HSOverlay;
  }
}

function MarketSelectionModal({onSelect, type = 'buy', marketRef}: MarketSelectionModalPropsT) {
  const handleSelectMarket = (market: {market_id: number; market_name: string}) => {
    onSelect(market);
    closeModal();
  };

  const closeModal = () => {
    const modal = document.querySelector('#hs-market-modal');
    if (modal instanceof HTMLElement) {
      window.HSOverlay.close(modal);
    }
  };

  return (
    <div id="hs-market-modal" className="hs-overlay ti-modal hidden">
      <div className="ti-modal-box m-3 mt-0 flex h-[calc(100%-3.5rem)] min-h-[calc(100%-3.5rem)] items-center ease-out hs-overlay-open:mt-7 lg:!mx-auto lg:w-full lg:!max-w-4xl">
        <div className="ti-modal-content max-h-full overflow-hidden">
          <div className="ti-modal-body">
            <div className="grid grid-cols-12 gap-x-6">
              <div className="col-span-12 xxl:col-span-12">
                <div className="box">
                  <div className="box-header justify-between">
                    <div className="box-title">Markets</div>
                    <div className="flex">
                      <div className="me-3">
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          placeholder="Search Here"
                          aria-label=".form-control-sm example"
                        />
                      </div>
                      <div className="ti-btn-list mr-3 flex gap-3">
                        {filterBtns.map(btn => (
                          <div className="ti-btn-group" key={btn.label}>
                            <div className="hs-dropdown ti-dropdown">
                              <button
                                className={`ti-btn ti-btn-outline-${btn.class} ti-dropdown-toggle`}
                                type="button"
                                aria-expanded="false"
                              >
                                {btn.label}
                                <i className="ri-arrow-down-s-line ms-1 inline-block align-middle"></i>
                              </button>
                              <ul className="hs-dropdown-menu ti-dropdown-menu hidden">
                                <li>
                                  <Link className="ti-dropdown-item" to="#">
                                    Action
                                  </Link>
                                </li>
                                <li>
                                  <Link className="ti-dropdown-item" to="#">
                                    Another action
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="hs-dropdown ti-dropdown">
                        <Link
                          to="#"
                          className="ti-btn ti-btn-primary !m-0 !gap-0 !bg-primary !px-2 !py-1 !text-[0.75rem] !font-medium !text-white"
                          aria-expanded="false"
                        >
                          Sort By<i className="ri-arrow-down-s-line ms-1 inline-block align-middle"></i>
                        </Link>
                        <ul className="hs-dropdown-menu ti-dropdown-menu hidden" role="menu">
                          <li>
                            <Link
                              className="ti-dropdown-item block !px-[0.9375rem] !py-2 !text-[0.8125rem] !font-medium"
                              to="#"
                            >
                              New
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="ti-dropdown-item block !px-[0.9375rem] !py-2 !text-[0.8125rem] !font-medium"
                              to="#"
                            >
                              Popular
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="box-body">
                    <div className="table-responsive">
                      {type === 'sell' ? (
                        <DataTable
                          staleTime={55000}
                          refetchInterval={60000}
                          ref={marketRef}
                          table="Market"
                          columns={['market_id', 'market_name']}
                          columnsDisplay={[
                            {
                              header: 'Market',
                              field: 'market_name',
                              render: row => (
                                <div className="flex w-40 items-center">
                                  <img
                                    src="/images/logo/logo.png"
                                    alt=""
                                    className="avatar avatar-md !mb-0 me-2 rounded-md leading-none"
                                  />
                                  <div>
                                    <p className="mb-0 font-semibold">{row.market_name}</p>
                                  </div>
                                </div>
                              ),
                            },
                          ]}
                          actionsDisplay={[
                            {
                              color: 'primary',
                              icon: 'ri-check-line',
                              handler: row => handleSelectMarket(row),
                              permission: () => true,
                            },
                          ]}
                          enabled={true}
                        />
                      ) : (
                        <DataTableRpc
                          functionName="get_market_position_aggregates"
                          functionArgs={{}}
                          sortOptions={[{column: 'total_item_count', direction: 'desc', label: 'Items'}]}
                          enabled={true}
                          columns={[
                            {
                              header: 'Market',
                              field: 'market_name',
                            },
                            {
                              header: 'Active Positions',
                              field: 'active_position_count',
                            },
                            {
                              header: 'Total Items',
                              field: 'total_item_count',
                            },
                          ]}
                          actions={[
                            {
                              color: 'primary',
                              icon: 'ri-check-line',
                              handler: row => handleSelectMarket(row),
                              permission: () => true,
                            },
                          ]}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ti-modal-footer">
            <button type="button" className="ti-btn ti-btn-secondary-full" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MarketSelectionModal;
